import { render } from "./catGroomingBannerComponent.vue?vue&type=template&id=4cf522a3"
import script from "./catGroomingBannerComponent.vue?vue&type=script&lang=js"
export * from "./catGroomingBannerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__